export const PUBLIC_PROFILE_INIT = 'PUBLIC_PROFILE_INIT'
export const PUBLIC_PROFILE_GET = 'PUBLIC_PROFILE_GET'
export const PUBLIC_PROFILE_GET_SUCCESS = 'PUBLIC_PROFILE_GET_SUCCESS'
export const PUBLIC_PROFILE_GET_FAILURE = 'PUBLIC_PROFILE_GET_FAILURE'
